import React from 'react';

import HorizontalScroll from '@components/HorizontalScroll';

import Chip from '@features/filter/Chip';
import Search from '@features/filter/Common/Search';

const CostingDetailsTopHeader = ({ toggleFilter, elementRef }) => {
	return (
		<>
			<div className="filter-container-top on-sample-details">
				<div className="filters">
					<div className="filter-toggle" onClick={() => toggleFilter()}>
						<img src={process.env.PUBLIC_URL + '/icons/filter24.svg'} alt="filter" />
						<span>Filter</span>
					</div>
					<Chip />
				</div>
				<div className="filter-actions sample-dashboard-filter">
					<div className="mr-12">
						<Search placeholder="Design name & number" identifier="search" />
					</div>
					<HorizontalScroll elementReference={elementRef.current} />
				</div>
			</div>
		</>
	);
};

export default CostingDetailsTopHeader;
